import InwardList from '../../slices/inventory/inward/InwardList'
import StockAvailabilityList from '../../slices/inventory/stockAvailability/StockAvailabilityList'
import OutwardList from '../../slices/inventory/outward/OutwardList'

const inventoryReducer = {
    inwardList: InwardList,
    stockAvailabilityList: StockAvailabilityList,
    outwardList: OutwardList,
};

export default inventoryReducer;